export default "__VITE_ASSET__B_IiZfzr__"